export function relativeTime(iso: string | null): string {
  if (!iso) return 'never';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 0) return 'just now';
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ${minutes % 60}m ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export type Staleness = 'fresh' | 'stale' | 'very-stale' | 'unknown';

export function staleness(iso: string | null, yellowMinutes: number, redMinutes: number): Staleness {
  if (!iso) return 'unknown';
  const minutes = (Date.now() - new Date(iso).getTime()) / 60_000;
  if (minutes < yellowMinutes) return 'fresh';
  if (minutes < redMinutes) return 'stale';
  return 'very-stale';
}

/** Formats a duration in seconds as e.g. "45s", "3m 20s", "2h 5m". */
export function humanDuration(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  const minutes = Math.floor(s / 60);
  const secs = s % 60;
  if (minutes < 60) return secs > 0 ? `${minutes}m ${secs}s` : `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
}
